<kendo-popup
    *ngIf="isOpened"
    (open)="popupOpened()"
    (click)="popupClicked($event)"
    (anchorViewportLeave)="isOpened = false"
    (close)="close()"
    [anchor]="popupAnchor"
    [anchorAlign]="anchorAlign"
    [popupAlign]="popupAlign"
    [collision]="collision"
>
<div class="popup-container" #wrapperContainer>
    <div class="container">
        <mat-checkbox
                data-qa-id="submittal-status-select-all"
                id="submittal-status-select-all"
                name="submittal-status-select-all"
                class="mat-list-option select-all-option"
                (change)="selectAll($event.checked)"
                [checked]="allSelected">
                Select All
        </mat-checkbox>
        <mat-divider></mat-divider>
    </div>
    <div class="options-container">
            <div *ngFor="let item of statuses">
                <mat-checkbox
                     class="mat-list-option checkbox-option"
                     [attr.data-qa-id]="item.name | replace: spaceRegex:''"
                     [name]="'submittal-status-' + item.id"
                     [id]="'submittal-status-' + item.id"
                     [indeterminate]="item.indeterminate"
                     (change)="updateStatus(item,$event.checked)"
                     [checked]="item.selected">
                     {{item.name}}
               </mat-checkbox>
               <div *ngIf="item.subStatuses && item.subStatuses.length">
                    <div class="sub-container">
                        <div *ngFor="let subStatus of item.subStatuses">
                        <mat-checkbox
                            class="mat-list-option sub-checkbox-option"
                            [attr.data-qa-id]="subStatus.name | replace: spaceRegex:''"
                            [name]="'submittal-sub-status-' + subStatus.id"
                            [id]="'submittal-sub-status-' + subStatus.id"
                            (change)="updateSubStatus(item,subStatus,$event.checked)"
                            [checked]="subStatus.selected">
                            {{subStatus.name}}
                        </mat-checkbox>
                        </div>
                    </div>
                </div>
           </div>
    </div>
    <div class="actions-container">
        <button data-qa-id="submittal-status-clear-all"
                id="submittal-status-clear-all"
                mat-raised-button
                (click)="clear()"
                class="mr-2 app-grid-header-right-button app-common">
                 Clear
        </button>
        <button data-qa-id="submittal-status-filter"
                id="submittal-status-filter"
                mat-raised-button
                (click)="close()"
                [disabled]="!selectionText"
                class="ml-1"
                color="primary">
               Filter
        </button>
    </div>
</div>
</kendo-popup>

<div class="filter">
    <div class="mat-form-field-appearance-fill">
        <div
            (click)="toggleFilter()"
            #popupAnchor
            data-qa-id="submittal-status-popupAnchor"
            id="submittal-status-popupAnchor"
            class="mat-form-field-flex">
            <div id="submittal-status-title"
                data-qa-id="submittal-status-title"
                class="title-selection"
                *ngIf="selectionText">Submittal Status</div>
            <div
                id="submittal-status-title"
                data-qa-id="submittal-status-title"
                class="title-no-selection"
                *ngIf="!selectionText">Submittal Status</div>
            <div class="selected"
                id="submittal-status-selected-text"
                data-qa-id="submittal-status-selected-text"
                *ngIf="selectionText">{{selectionText}}</div>
            <mat-icon matSuffix class="arrow-down">arrow_drop_down</mat-icon>
        </div>
    </div>
</div>
